<script setup lang="ts">
import { onMounted, onUnmounted, ref, toRaw, watch } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { formatDate, mapOptionMultiselect } from "@/utils/helper";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { toast } from "vue-sonner";
import { useCategoryStore } from "@/stores/master/category-store";
import { useCategoryGroupStore } from "@/stores/master/category-group-store";
import { useItemStore } from "@/stores/management/item";
import { db } from "@/database/db";
import {
  RequisitionResponse,
  VariantInterface,
} from "@/types/interface/requisition";
import { useRequisitionStore } from "@/stores/management/requisition";
import { useRequisitionItemStore } from "@/stores/management/requisition-item";
import Swal from "sweetalert2";
import { useVesselItemStore } from "@/stores/management/item-vessel";
import isOnline from 'is-online';

const idRequisition = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const vesselItemStore = useVesselItemStore();
const requisitionStore = useRequisitionStore();
const requisitionItemStore = useRequisitionItemStore();
const categoryStore = useCategoryStore();
const groupCategoryStore = useCategoryGroupStore();
const itemStore = useItemStore();
const listItem = ref<any>([]);
const listItemDixie = ref<any>([]);
const modalShow = ref<any>(false);
const queryTemp = ref<any>("");
const itemTemp = ref<any>();
const qtyTemp = ref<any>();
const haveVarian = ref(false);
const listVariant = ref([]);
const variant = ref<VariantInterface>();
const rob = ref(0);
const est_rob = ref(0);
const remark = ref("");
const isEditProduct = ref(false);
const showProductForm = ref(false);
const requisitionDetail = ref<RequisitionResponse>();
const requisitionId = ref<number>();
let modalInstance: any;

interface CheckExisting {
  existance: boolean;
  data: any;
}

const category = ref("");
const categoryVal = ref("");
const group_category = ref("");
const group_categoryVal = ref("");
const port = ref("");
const date = ref("");
const msg_id = ref("");
const vessel = ref("");
const vessel_id = ref("");
const pic_onboard = ref("");
const form_no = ref("");
const ref_no = ref("");
const req_status = ref("");
const priority = ref("");
const remarkReq = ref("");
const maxQuantity = ref("");

const emptyStateModal = () => {
  modalShow.value = false;
  qtyTemp.value = "";
  itemTemp.value = "";
  remark.value = "";
  variant.value = { value: null, label: null };
  rob.value = 0;
  est_rob.value = 0;
  isEditProduct.value = false;
  haveVarian.value = false;
};

const addProductToDixie = async (item: any) => {
  item.forEach(async (element) => {
    await db.product.put({
      requisition_id: requisitionId.value,
      id_product: element?.item_id,
      data: toRaw(element),
      qty: element.qty_required,
      remark: element.remark,
      id_variant: element.variant_id,
      variant: toRaw({
        value: element.variant_id,
        label: element.variant_key + "-" + element.variant_value,
      }),
      rob: element.rob,
    });
  });
};

const loadRequisition = async () => {
  const { success, message } = await requisitionStore.dispatchDetail(
    idRequisition.value
  );
  if (success) {
    requisitionDetail.value = requisitionStore?.requisition?.data;
    category.value =
      requisitionDetail.value.category.code +
      " - " +
      requisitionDetail.value.category.name;
    group_category.value =
      requisitionDetail.value.groupCategory.code +
      " (" +
      requisitionDetail.value.groupCategory.name +
      ")";
    port.value =
      requisitionDetail.value.port.name +
      " - " +
      requisitionDetail.value.port.country;
    categoryVal.value = requisitionDetail.value.category;
    group_categoryVal.value = requisitionDetail.value.groupCategory;
    date.value = formatDate(requisitionDetail.value.created_at);
    msg_id.value = requisitionDetail.value?.groupCategory?.code;
    pic_onboard.value = requisitionDetail.value?.pic_onboard;
    form_no.value = requisitionDetail.value?.form_no;
    ref_no.value = requisitionDetail.value?.ref_no;
    requisitionId.value = requisitionDetail.value.id;
    priority.value = requisitionDetail.value.priority;
    req_status.value = requisitionDetail.value.requisition_status?.name;
    remarkReq.value = requisitionDetail.value.remarks;
    showProductForm.value = true;
    buildQuery();
    // if (requisitionDetail.value?.requisitionItem.length > 0) {
    //   addProductToDixie(requisitionDetail.value.requisitionItem);
    // }
    loadProductFromDixie();
  }
};

const loadDataItem = async () => {
  const { success, message } = await itemStore.dispatchGetCatalogs(
    1,
    99,
    queryTemp.value
  );
  if (success) {
    listItem.value = mapOptionMultiselect(
      await itemStore.items?.items,
      "id",
      "name"
    );
  }
};

const loadUserLogin = async () => {
  let getDataLogin = await db.storage.get("login-info");
  let userLogin = getDataLogin?.data;
  vessel.value = `${userLogin?.vessel?.name} (${userLogin?.vessel?.call_sign})`;
  vessel_id.value = userLogin?.vessel?.id;
};

const loadProductFromDixie = async () => {
  const products = await db.product
    .where({ requisition_id: requisitionId.value })
    .toArray();
    console.log(products);
  listItemDixie.value = products;
};

const buildQuery = async (search = "") => {
  queryTemp.value = "";
  if (categoryVal.value != undefined) {
    const { success } = await categoryStore.dispatchDetail(
      categoryVal.value?.id
    );
    if (success) {
      queryTemp.value =
        queryTemp.value + "&category_code=" + categoryStore.category.data.code;
    }
  }

  if (group_categoryVal.value != undefined) {
    const { success } = await groupCategoryStore.dispatchDetail(
      group_categoryVal.value?.id
    );
    if (success) {
      queryTemp.value =
        queryTemp.value +
        "&group_category_code=" +
        groupCategoryStore.categoryGroup.data.code;
      msg_id.value = groupCategoryStore.categoryGroup.data.code;
    }
  }

  if (search != undefined) {
    queryTemp.value = queryTemp.value + "&keyword=" + search;
  }

  loadDataItem();
};

let debounceTimeoutItem: any;

const handleSearch = (query: string) => {
  clearTimeout(debounceTimeoutItem);
  debounceTimeoutItem = setTimeout(() => {
    buildQuery(query);
  }, 500);
};

const loadDetailProduct = async (id: string) => {
  const { success } = await itemStore.dispatchDetail(id);
  if (success) {
    return itemStore.item?.data;
  }
};

const loadSpecificDetail = async (id: string) => {
  let queryParams = "?vessel_id=" + vessel_id.value + "&goods_id=" + id;
  if (haveVarian.value) {
    queryParams = queryParams + "&variant_id=" + variant.value?.value;
  }
  const { success } = await vesselItemStore.dispatchSpecificDetail(queryParams);
  if (success) {
    rob.value = vesselItemStore.vesselItem?.data?.rob;
    maxQuantity.value = vesselItemStore.vesselItem?.data?.quantity;
    return vesselItemStore.vesselItem?.data;
  }
};

const chooseVariant = async () => {
  let specificDetail = await loadSpecificDetail(itemTemp.value?.value);
};

const chooseItem = async () => {
  let detailProduct = await loadDetailProduct(itemTemp.value?.value);
  let specificDetail = await loadSpecificDetail(itemTemp.value?.value);
  if (detailProduct?.variant.length > 0) {
    haveVarian.value = true;
    listVariant.value = mapOptionMultiselect(
      detailProduct?.variant,
      "id",
      "key",
      "value"
    );
  } else {
    haveVarian.value = false;
    listVariant.value = [];
  }
};

const existingProduct = async (
  idProduct: number,
  idVariant: number
): Promise<CheckExisting> => {
  let existing = null;
  if (haveVarian.value) {
    existing = await db.product
      .where({
        id_product: idProduct,
        id_variant: idVariant,
        requisition_id: requisitionId.value,
      })
      .first();
    if (!existing && isEditProduct.value == true) {
      existing = await db.product
        .where({ id_product: idProduct, requisition_id: requisitionId.value })
        .first();
    }
  } else {
    existing = await db.product
      .where({ id_product: idProduct, requisition_id: requisitionId.value })
      .first();
  }
  return {
    existance: !!existing,
    data: existing,
  };
};

const addItemDixie = async () => {
  let error = 0;
  let errMessage = "";
  if (itemTemp.value == undefined && error == 0) {
    error = 1;
    errMessage = "Item can not empty";
  }

  if (qtyTemp.value == undefined && error == 0) {
    error = 1;
    errMessage = "Qty Required can not empty";
  }

  if (remark.value == "" && error == 0) {
    error = 1;
    errMessage = "Remark can not empty";
  }

  if (await isOnline()) {
    const variantExist = variant.value?.value ? variant.value?.value : null;
    const responseCheck = await requisitionItemStore.dispatchCheckExistingRequest(Number(vessel_id.value), itemTemp.value?.value, variantExist);

    if (responseCheck.data) {
      Swal.fire({
        title: "The item is already requested.",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Yes",
        denyButtonText: `No`,
        text: responseCheck.message,
      }).then(async (result) => {
        if (result.isConfirmed) {

          if (error == 0) {
            if (qtyTemp.value + rob.value <= maxQuantity.value) {
              let detailProduct = await loadDetailProduct(itemTemp.value?.value);
              let resultExisiting = await existingProduct(
                itemTemp.value?.value,
                variant.value?.value
              );
              if (isEditProduct.value) {
                await db.product.update(resultExisiting.data.id, {
                  qty:
                    isEditProduct.value == true
                      ? qtyTemp.value
                      : qtyTemp.value + resultExisiting.data.qty,
                  variant: toRaw(variant.value),
                  rob: rob.value,
                  est_rob: est_rob.value,
                  remark: remark.value,
                });
                toast.success("Item successfully updated");
              } else {
                if (!resultExisiting.existance) {
                  await db.product.put({
                    requisition_id: requisitionId.value,
                    id_product: detailProduct?.id,
                    data: toRaw(detailProduct),
                    qty: qtyTemp.value,
                    id_variant: variant.value?.value,
                    variant: toRaw(variant.value),
                    remark: remark.value,
                    rob: rob.value,
                    est_rob: est_rob.value,
                  });
                  toast.success("Item successfully added");
                } else {
                  await db.product.update(resultExisiting.data.id, {
                    qty:
                      isEditProduct.value == true
                        ? qtyTemp.value
                        : qtyTemp.value + resultExisiting.data.qty,
                    variant: toRaw(variant.value),
                    rob: rob.value,
                    est_rob: est_rob.value,
                    remark: remark.value,
                  });
                  toast.success("Item successfully updated");
                }
              }
              emptyStateModal();
              loadProductFromDixie();
            } else {
              toast.error(
                `'Can not input qty required more than max capacity of item, the max capacity is ${maxQuantity.value}'`
              );
            }
          } else {
            toast.error(errMessage);
          }
          
        }
      });
    } else {
      if (qtyTemp.value + rob.value <= maxQuantity.value) {
        let detailProduct = await loadDetailProduct(itemTemp.value?.value);
        let resultExisiting = await existingProduct(
          itemTemp.value?.value,
          variant.value?.value
        );
        if (isEditProduct.value) {
          await db.product.update(resultExisiting.data.id, {
            qty:
              isEditProduct.value == true
                ? qtyTemp.value
                : qtyTemp.value + resultExisiting.data.qty,
            variant: toRaw(variant.value),
            rob: rob.value,
            est_rob: est_rob.value,
            remark: remark.value,
          });
          toast.success("Item successfully updated");
        } else {
          if (!resultExisiting.existance) {
            await db.product.put({
              requisition_id: requisitionId.value,
              id_product: detailProduct?.id,
              data: toRaw(detailProduct),
              qty: qtyTemp.value,
              id_variant: variant.value?.value,
              variant: toRaw(variant.value),
              remark: remark.value,
              rob: rob.value,
              est_rob: est_rob.value,
            });
            toast.success("Item successfully added");
          } else {
            await db.product.update(resultExisiting.data.id, {
              qty:
                isEditProduct.value == true
                  ? qtyTemp.value
                  : qtyTemp.value + resultExisiting.data.qty,
              variant: toRaw(variant.value),
              rob: rob.value,
              est_rob: est_rob.value,
              remark: remark.value,
            });
            toast.success("Item successfully updated");
          }
        }
        emptyStateModal();
        loadProductFromDixie();
      } else {
        toast.error(
          `'Can not input qty required more than max capacity of item, the max capacity is ${maxQuantity.value}'`
        );
      }
    } 

    return;
  } else {
    const param = {
      requisition_id: requisitionId.value,
      id_product: itemTemp.value?.value,
    };
    
    if (variant.value?.value) param.id_variant = variant.value?.value;

    let resultExisiting = db.product.get(param);

    if (resultExisiting?.id) {
      await db.product.update(resultExisiting.id, {
        qty:
          isEditProduct.value == true
            ? qtyTemp.value
            : qtyTemp.value + resultExisiting.qty,
        variant: toRaw(variant.value),
        rob: rob.value,
        est_rob: est_rob.value,
        remark: remark.value,
      });
      toast.success("Item successfully updated");
    } else {
      await db.product.put({
        requisition_id: requisitionId.value,
        id_product: itemTemp.value?.value,
        // data: toRaw(resultExisiting),
        qty: qtyTemp.value,
        id_variant: variant.value?.value,
        // variant: toRaw(variant.value),
        remark: remark.value,
        rob: rob.value,
        est_rob: est_rob.value,
      });
      toast.success("Item successfully added");
    }

    emptyStateModal();
    loadProductFromDixie();
    return;
  }

};

const handleEditProduct = async (id: number) => {
  isEditProduct.value = true;
  loadDataItem();
  modalShow.value = true;
  let getDataTemp = await db.product.get(id);
  if (getDataTemp.data?.name === undefined) {
    itemTemp.value = mapOptionMultiselect(
      getDataTemp?.data,
      "item_id",
      "item_name"
    );
  } else {
    itemTemp.value = mapOptionMultiselect(getDataTemp?.data, "id", "name");
  }
  qtyTemp.value = getDataTemp?.qty;
  est_rob.value = getDataTemp?.rob;
  remark.value = getDataTemp?.remark;
  let detailProduct = await loadDetailProduct(getDataTemp?.id_product);
  if (getDataTemp?.variant != undefined) {
    listVariant.value = mapOptionMultiselect(
      detailProduct?.variant,
      "id",
      "key",
      "value"
    );
    haveVarian.value = true;
    variant.value = getDataTemp?.variant;
  } else {
    haveVarian.value = false;
  }
  let specificDetail = await loadSpecificDetail(getDataTemp?.id_product);
};

const handleDeleteProduct = async (id: number) => {
  await db.product.delete(id);
  toast.error("Successfully delete item");
  loadProductFromDixie();
};

const doSubmitRequisition = async (status = "") => {
  let submitPayload = {};
  let itemRequisition = [];
  let products = await db.product
    .where({ requisition_id: requisitionId.value })
    .toArray();

  products.forEach((element) => {
    itemRequisition.push({
      goods_id: element.id_product,
      variant_id: element.id_variant ? element.id_variant : null,
      rob_estimate: element.rob,
      qty_required: element.qty,
      remarks: element.remark,
    });
  });

  submitPayload.requisition_id = requisitionId.value;
  submitPayload.status = status;
  submitPayload.item = itemRequisition;

  if (itemRequisition.length < 1) {
    toast.error('Requisition items cannot be empty.');
    return;
  }

  const {success, message} = await requisitionItemStore.dispatchCreate(
    submitPayload
  ).catch((error) => {toast.error(error.message);});

    const submitDraft = await requisitionStore.dispatchSubmitDraft(
      idRequisition.value,
    ).catch((error) => {toast.error(error.message);});

  if (submitDraft?.success) {
    toast.success("Successfully submit requisition form");
    setTimeout(() => {
      router.push("/management/requisition");
    }, 1500);
  } else {
    toast.error(submitDraft?.message);
  }
  await db.product.where({ requisition_id: requisitionId.value }).delete();
};

const doSubmitDraft = () => {
  toast.info("Your data will be save as draft");

  setTimeout(() => {
    router.push("/management/requisition");
  }, 1000);
};

onMounted(() => {
  setTimeout(() => {
    const modalEl = document.getElementById("modalItem");
    if (modalEl) {
      const bootstrap = (window as any).bootstrap;
      modalInstance = new bootstrap.Modal(modalEl);
    }
  }, 1000);
  loadUserLogin();
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idRequisition.value = router.currentRoute.value.params.id.toString();
    loadRequisition();
  }
});

const backToListRequisition = () => {
  handleBeforeReloadModal("/management/requisition");
};

const handleBeforeReloadModal = (to: any) => {
  Swal.fire({
    title: "Are you sure want to leave requisition page ?",
    showDenyButton: true,
    showCancelButton: false,
    confirmButtonText: "Yes",
    denyButtonText: `No`,
    text: "All data will deleted, unless you already save before",
  }).then((result) => {
    if (result.isConfirmed) {
      router.push(to);
    }
  });
};

watch(modalShow, (newVal) => {
  if (modalInstance) {
    if (newVal) {
      modalInstance.show();
    } else {
      modalInstance.hide();
    }
  }
});
</script>

<template>
  <div class="row justify-content-center">
    <div class="col-lg-12">
      <div class="card bg-white border-0 rounded-3">
        <div class="card-body p-4">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4"
          >
            <h3 class="mb-0">Form Create Requisition</h3>
            <a
              class="btn btn-danger fw-semibold text-white px-3 btn-back"
              type="button"
              @click="backToListRequisition"
            >
              <i class="ri-arrow-drop-left-line text-gray-light"></i>
              Back To List Requisition
            </a>
          </div>
          <BaseLoading text="Processing Data..." v-if="isLoading" />
          <form
            @submit="onSubmit"
            class="row g-3 needs-validation form"
            v-if="!isLoading"
          >
            <div class="row">
              <div class="col-lg-4">
                <div class="form-group">
                  <label for="vessel" class="form-label label text-secondary"
                    >Vessel <span class="text-danger">*</span></label
                  >
                  <div class="position-relative">
                    <input
                      name="vessel"
                      v-model="vessel"
                      placeholder="Vessel"
                      type="text"
                      class="form-control text-dark"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <label for="port" class="form-label label text-secondary"
                    >Port <span class="text-danger">*</span></label
                  >
                  <div class="form-group">
                    <div class="position-relative">
                      <input
                        name="port"
                        v-model="port"
                        placeholder="Port"
                        type="text"
                        class="form-control text-dark"
                        readonly
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <label for="date" class="form-label label text-secondary"
                    >Date Receipt <span class="text-danger">*</span></label
                  >
                  <div class="position-relative">
                    <input
                      name="date"
                      v-model="date"
                      placeholder="Date Receipt"
                      type="date"
                      class="form-control text-dark"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <label for="category" class="form-label label text-secondary"
                    >Category <span class="text-danger">*</span></label
                  >
                  <div class="form-group">
                    <div class="position-relative">
                      <input
                        name="category"
                        v-model="category"
                        placeholder="category"
                        type="text"
                        class="form-control text-dark"
                        readonly
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <label
                    for="group_category"
                    class="form-label label text-secondary"
                    >Group Category <span class="text-danger">*</span></label
                  >
                  <div class="form-group">
                    <div class="position-relative">
                      <input
                        name="group_category"
                        v-model="group_category"
                        placeholder="group_category"
                        type="text"
                        class="form-control text-dark"
                        readonly
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <label for="msg_id" class="form-label label text-secondary"
                    >MSG ID <span class="text-danger">*</span></label
                  >
                  <div class="position-relative">
                    <input
                      name="msg_id"
                      v-model="msg_id"
                      placeholder="MSG ID"
                      type="text"
                      class="form-control text-dark"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <label for="pic" class="form-label label text-secondary"
                    >PIC Onboard <span class="text-danger">*</span></label
                  >
                  <div class="form-group">
                    <input
                      name="pic"
                      v-model="pic_onboard"
                      placeholder="PIC Onboard"
                      type="text"
                      class="form-control text-dark"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <label for="priority" class="form-label label text-secondary"
                    >Priority <span class="text-danger">*</span></label
                  >
                  <div class="form-group">
                    <input
                      name="priority"
                      v-model="priority"
                      placeholder="Priority"
                      type="text"
                      class="form-control text-dark"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <label
                    for="req_status"
                    class="form-label label text-secondary"
                    >Requisition Status
                    <span class="text-danger">*</span></label
                  >
                  <div class="form-group">
                    <input
                      name="req_status"
                      v-model="req_status"
                      placeholder="Requisition Status"
                      type="text"
                      class="form-control text-dark"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <label for="remarkReq" class="form-label label text-secondary"
                    >Remark <span class="text-danger">*</span></label
                  >
                  <div class="form-group">
                    <textarea
                      name="remarkReq"
                      v-model="remarkReq"
                      placeholder="Requisition Remark"
                      type="text"
                      class="form-control text-dark"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="submit-button">
              <button
                type="button"
                class="btn btn-info me-3 text-white btn-draft"
                @click="doSubmitDraft()"
              >
                Save As Draft
              </button>
              <button
                type="button"
                class="btn btn-primary btn-submit"
                @click="doSubmitRequisition('submit')"
                v-if="showProductForm"
              >
                Submit Form Requisition
              </button>
            </div>
            <button
              type="submit"
              class="btn btn-primary"
              v-if="!showProductForm"
            >
              Create Form Requisition
            </button>
          </form>
        </div>
      </div>
      <div
        class="card bg-white border-0 rounded-3 mb-4 mt-4"
        v-if="showProductForm"
      >
        <div class="card-body p-4">
          <div class="d-flex justify-content-between align-items-center mb-4">
            <button
              type="button"
              class="btn btn-primary"
              @click="modalShow = true"
            >
              Add Item
            </button>
          </div>

          <div class="table mt-3">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">No</th>
                  <th scope="col">Item Description</th>
                  <th scope="col">Remark</th>
                  <th scope="col">Qty Required</th>
                  <th scope="col">Unit</th>
                  <th scope="col">ROB</th>
                  <th scope="col">EST ROB</th>
                  <th scope="col">IMPA</th>
                  <th scope="col">MSG CODE</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in listItemDixie" :key="index + 1">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>
                    {{ item?.data?.name ?? item?.data?.item_name }}
                    <span v-if="item.variant?.value != null"
                      >- {{ item?.variant?.label }}</span
                    >
                  </td>
                  <td>{{ item?.remark }}</td>
                  <td>{{ item?.qty }}</td>
                  <td>{{ item?.data?.unitType?.name ?? item?.data?.unit }}</td>
                  <td>{{ item?.rob }}</td>
                  <td>{{ item?.est_rob }}</td>
                  <td>{{ item?.data?.impa_code }}</td>
                  <td>{{ item?.data?.msg_code }}</td>
                  <td>
                    <div class="d-flex justify-content-around">
                      <button
                        type="button"
                        class="btn btn-success text-white btn-edit"
                        @click="handleEditProduct(item?.id)"
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger btn-delete"
                        @click="handleDeleteProduct(item?.id)"
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="modalItem"
    tabindex="-1"
    aria-labelledby="modalItemLabel"
    aria-hidden="false"
    data-bs-backdrop="static"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalItemLabel">Modal Form Add Item</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="emptyStateModal"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="form-group">
                <label for="item" class="form-label label text-secondary"
                  >Item <span class="text-danger">*</span></label
                >
                <div class="form-group">
                  <vSelect
                    v-model="itemTemp"
                    :options="listItem"
                    placeholder="Choose Item"
                    @search="handleSearch"
                    @close="chooseItem"
                  ></vSelect>
                </div>
              </div>
            </div>
            <div class="col-lg-12" v-if="haveVarian && (listVariant.length > 0)">
              <div class="form-group">
                <label for="varian" class="form-label label text-secondary"
                  >Varian <span class="text-danger">*</span></label
                >
                <div class="form-group">
                  <vSelect
                    v-model="variant"
                    :options="listVariant"
                    placeholder="Choose Varian Item"
                    @close="chooseVariant"
                  ></vSelect>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label for="rob" class="form-label label text-secondary"
                  >Rob <span class="text-danger">*</span></label
                >
                <div class="position-relative">
                  <input
                    name="rob"
                    v-model="rob"
                    placeholder="Remaining Quantity"
                    type="number"
                    class="form-control text-dark"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label for="est_rob" class="form-label label text-secondary"
                  >Estimate ROB <span class="text-danger">*</span></label
                >
                <div class="position-relative">
                  <input
                    name="est_rob"
                    v-model="est_rob"
                    placeholder="Est Remaining Quantity"
                    type="number"
                    class="form-control text-dark"
                  />
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <div class="form-group">
                <label for="qty" class="form-label label text-secondary"
                  >Qty <span class="text-danger">*</span></label
                >
                <div class="position-relative">
                  <input
                    name="qty"
                    v-model="qtyTemp"
                    placeholder="Qty Required"
                    type="number"
                    class="form-control text-dark"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="form-group">
                <label for="remark" class="form-label label text-secondary"
                  >Remark <span class="text-danger">*</span></label
                >
                <div class="position-relative">
                  <textarea
                    name="remark"
                    v-model="remark"
                    placeholder="Remark"
                    class="form-control text-dark"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="emptyStateModal"
          >
            Close
          </button>
          <button type="button" class="btn btn-primary" @click="addItemDixie">
            Add
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.v-select {
  background-color: white;
}
.btn {
  padding: 0.5rem 1rem;
  font-weight: 500;
  border: none !important;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
  font-size: 14px;
  text-align: center;
  display: inline-block;
}

.btn-back {
  background-color: #6c757d !important;
  color: #ffffff !important;
}
.btn-back:hover {
  background-color: #5a6268 !important;
}

.btn-submit {
  background-color: #28a745 !important;
  color: #ffffff !important;
}
.btn-submit:hover {
  background-color: #218838 !important;
}

.btn-draft {
  background-color: #17a2b8 !important;
  color: #ffffff !important;
}
.btn-draft:hover {
  background-color: #138496 !important;
}

.btn-add {
  background-color: #007bff !important;
  color: #ffffff !important;
}
.btn-add:hover {
  background-color: #0069d9 !important;
}

.btn-edit {
  background-color: #ffc107 !important;
  color: #212529 !important;
}
.btn-edit:hover {
  background-color: #e0a800 !important;
}

.btn-delete {
  background-color: #dc3545 !important;
  color: #ffffff !important;
}
.btn-delete:hover {
  background-color: #c82333 !important;
}
</style>
